// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3Hnia","inputWrap":"styles_inputWrap__2c3wv","input":"styles_input__1BWDj"};